var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfResultsStepArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 5.7735,
    height: 24.5,
    viewBox: "0 0 5.7735 24.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Downward arrow",
    d: "M3.38675 0.5V0H2.38675V0.5H2.88675H3.38675ZM2.38675 1.475V1.975H3.38675V1.475H2.88675H2.38675ZM3.38675 3.425V2.925H2.38675V3.425H2.88675H3.38675ZM2.38675 5.375V5.875H3.38675V5.375H2.88675H2.38675ZM3.38675 7.325V6.825H2.38675V7.325H2.88675H3.38675ZM2.38675 9.275V9.775H3.38675V9.275H2.88675H2.38675ZM3.38675 11.225V10.725H2.38675V11.225H2.88675H3.38675ZM2.38675 13.175V13.675H3.38675V13.175H2.88675H2.38675ZM3.38675 15.125V14.625H2.38675V15.125H2.88675H3.38675ZM2.38675 17.075V17.575H3.38675V17.075H2.88675H2.38675ZM3.38675 19.025V18.525H2.38675V19.025H2.88675H3.38675ZM2.88675 0.5H2.38675V1.475H2.88675H3.38675V0.5H2.88675ZM2.88675 3.425H2.38675V5.375H2.88675H3.38675V3.425H2.88675ZM2.88675 7.325H2.38675V9.275H2.88675H3.38675V7.325H2.88675ZM2.88675 11.225H2.38675V13.175H2.88675H3.38675V11.225H2.88675ZM2.88675 15.125H2.38675V17.075H2.88675H3.38675V15.125H2.88675ZM2.88675 19.025H2.38675V20H2.88675H3.38675V19.025H2.88675ZM2.88675 24.5L5.7735 19.5H0L2.88675 24.5Z",
    fill: "url(#paint0_linear_0_145)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_145",
    x1: 3.38675,
    y1: 0.5,
    x2: 3.38675,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59402",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59402",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfResultsStepArrow);
export default __webpack_public_path__ + "static/media/cf-results-step-arrow.eb94d466e053a0993652e300a42d6461.svg";
export { ForwardRef as ReactComponent };